// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkButton_link__2ut4b","link-color":"LinkButton_link-color__EjCAP","icon":"LinkButton_icon__13mim"};